export default __webpack_public_path__ + "static/media/ezpoz-logo.554db718.png";